
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import './plugins/iview.js'
import './plugins/element.js'
import cookie from 'vue-cookies'
import axios from './http'
import Upload from './components/upload'
import Confirm from './components/confirm'
import utils from './utils/utils.js'
import paymentAlert from './components/payment-alert'
import cancelOrder from './components/cancel-order'

// 没师傅报价的空状态 组件
import EmptyTime from './components/empty-time'

Vue.component('CustomUpload', Upload)
Vue.component('EmptyTime', EmptyTime)
Vue.use(cookie)

Vue.use(Confirm)
Vue.use(paymentAlert)
Vue.use(cancelOrder)
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$util = utils
Vue.prototype.$request = (url, data, method = 'post') => {
  const requestOptions = {
    url: url,
    method: method
  }
  if (String(method).toLowerCase() === 'get') {
    requestOptions.params = data
  } else {
    requestOptions.data = data
  }
  return axios.request(requestOptions)
}

Vue.config.productionTip = false
store.dispatch('init')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
